import React, { useState, useEffect } from 'react';
import { IonText } from '@ionic/react';
import "./ManageUser.page.scss";
import { USER_BACK_TITLE, USER_BACK_MESSAGE, USER_FORM_ERRORS, NO, YES, EDIT_USER, ADD_USER, USER_EXIST_MESSAGE, USER_EXIST_TITLE, TRACTOR_NUMBER, EDIT_PROFILE, BUTTONS, ALL_FIELDS_REQUIRED_TEXT, TRACTOR_NUMBER_ERROR, deLinkHeader, deLinkContent, defaultCountryCode } from '../../../utils/constants';
import { IRole, ITransferRequest } from '../../../schemas/manage/manage.Schema';
import {
  removeSpecial, roles, defaultForm, getSelectedRoles,getRequestedRoles, isValidString,
  formatRoles
} from '../userProfile/userProfileUtil';
import _, { isEqual }from "lodash";
import { EnumType } from 'json-to-graphql-query';
import ManageUserValidateForm from './ManageUserValidateForm';
import ManageUserFormFields from './ManageUserFormFields';
import { setScreenName } from '../../../utils/Analytics';
import { normalizeInput, updatedRoles } from '../../../pages/Manage/ManageUser/ManageUserUtil';
import { CustomModalWeb } from '../userProfile/CustomModalWeb';
import { IONICWrapper } from '../../../utils/common';
import { isElevatedLeasedOwenerOprRoleOnSelectedUser, isLeasedOwnerOprRoleOnlyOnSelectedUser, isLeasedOwnerOprRoleOnSelectedUser } from '../../../utils/roleUtil/RoleUtil';

const ADD_BACK_PATH = '/app/manage/ManageUser';
const EDIT_BACK_PATH = '/app/manage/ManageUser/Profile';
const BACK_TO_PROFILE = '/app/manage/ProfileDetails';

const ManageUserProfileFormPage: React.FC<any> = (props) => {
  const { userDetails: { memberDetailsResponse },
    isSelf = false, selectedUser = null, validateUserDetails = null,
    isUserValid = null, resetValidateUser = null, history, isNetworkAvailable,
    showNetworkAlert, addMode } = props;
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [mobileValidateError, setMobileValidateError] = useState(false); 
  const [isUserNotExist, setUserNotExist] = useState(false);
  const [isDriverSelected, setDriverSelected] = useState(true);
  const [alertProps, setAlertProps] = useState<any>(null);
  const [formFields, setFormFields] = useState<any>({ ...defaultForm, roles: getSelectedRoles(roles), requestedRoles:getRequestedRoles(roles) && getRequestedRoles(roles).toString(),carrierId :memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId });
  const [isAddressEdit, setAddressEdit] = useState(true);
  const [isValidateButton, setIsValidateButton] = useState(true);
  const [formErrors, setFormErrors] = useState<any>({
    firstName: '',
    lastName: '',
    emailAddress: '',
    tractorNumber: '',
  });
  const [isFormEdit, setFormEdit] = useState(false);
  const [isFormValid, setFormValid] = useState(false);
  const [reset, setReset] = useState(false);
  const [isonlyDriverSelected, setIsonlyDriverSelected] = useState(true);
  const [selectedDetails, setSelectedDetails] = useState({
    ...defaultForm,
    roles: getSelectedRoles(roles),
    carrierId:memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId,
    requestedRoles:getRequestedRoles(roles) && getRequestedRoles(roles).toString()
  })
  const [restrictUserModalProps,setRestrictUserModalProps] = useState<any>({isModalOpen: false});
  const [onClickRestrictUserModalNo,setOnClickRestrictUserModalNo] = useState(false);
  const [onClickRestrictUserModalYes,setOnClickRestrictUserModalYes] = useState(false);
  const [onClickRestrictUserModalNone,setOnClickRestrictUserModalNone] = useState(false);

  const resetData = () => {
    setAlertProps(null);
    setFormValid(false);
    setReset(true);
    setFormEdit(false);
    if (!selectedUser) {
      setUserNotExist(false);
      setFormErrors({
        firstName: '',
        lastName: '',
        emailAddress: '',
        tractorNumber: ''
      });
      resetValidateUser();
      setFormFields({ ...defaultForm, roles: getSelectedRoles(roles), carrierId :memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId, requestedRoles:getRequestedRoles(roles) && getRequestedRoles(roles).toString()});
    } else {
      const selectedRoles = roles.map((role: IRole) => ({ ...role, selected: selectedUser && selectedUser.roles.indexOf(role.value.toString()) !== -1 }));
      const details: any = getFormatedFormFields(selectedUser);
      setFormFields({
        ...details,
        roles: formatRoles(selectedUser && selectedUser.roles, selectedRoles)
      });
    }
  }

  const validateErrors = () => {
    const regEx = /^[a-zA-Z0-9.-]+@[a-zA-Z0-9-]+\.[A-Za-z]+$/;
    const isEmailValid = regEx.test(formFields.email);
    let errorsTexts = { ...formErrors, emailAddress: isonlyDriverSelected ? false : !isEmailValid ? USER_FORM_ERRORS['emailAddress'] : false }
    const errors = Object.keys(errorsTexts).filter(key => errorsTexts[key] !== false);
    const isManadatoryEmpty = Object.keys(errorsTexts).filter(key => (isDriverSelected || isLeasedOwnerOprRoleOnSelectedUser(updatedRoles(formFields?.roles)) || isLeasedOwnerOprRoleOnlyOnSelectedUser(selectedUser?.roles) || isElevatedLeasedOwenerOprRoleOnSelectedUser(selectedUser?.roles)) ? formFields[key] === '' : formFields[key] === '' && key !== 'tractorNumber');
    if (errors.length > 0 || isManadatoryEmpty.length > 0) {
      let errorsText = errorsTexts;
      errors.forEach((key: string) => {
        errorsText[key] = USER_FORM_ERRORS[key];
      })
      isManadatoryEmpty.forEach((key: string) => {
        errorsText[key] = USER_FORM_ERRORS[key];
      })
      setFormErrors(errorsText);
      setFormFields({ ...formFields });
      return true;
    }
    return false;
  }

  const getFormatedFormFields = (selectedUser: any) => ({
    userId: selectedUser?.userPrincipalName === null || selectedUser?.upn === null? "null": (selectedUser.userPrincipalName || selectedUser.upn),
    roles: [],
    firstName: selectedUser.firstName,
    lastName: selectedUser.lastName,
    email: selectedUser.email,
    mobileNumber: selectedUser.mobileNumber,
    tractorNumber: selectedUser.tractorNumber,
    addressDTOs: selectedUser.address && selectedUser.address.length > 0 ? selectedUser.address[0] : {
      addressLine1: "",
      addressLine2: "",
      addressType: "",
      city: "",
      state: "",
      postalCode: "",
    },
    carrierId: selectedUser.carrierId,
  });

  useEffect(() => {
    if (isUserValid !== null && !mobileValidateError) {   // If Error in existing user phoneNumber Validation API  
          setUserNotExist(!isUserValid);
          handleUserExistModal(isUserValid);
      }
      if(isUserValid === null) {
        setUserNotExist(false);
      }
  }, [isUserValid]);

  useEffect(() => {
    if (selectedUser) {
      const selectedRoles = roles.map((role: IRole) => ({ ...role, selected: selectedUser.roles.indexOf(role.value.toString()) !== -1 }));
      const isDriver = selectedRoles.find((role: any) => role.selected && role.label === 'Driver');
      setDriverSelected(!!isDriver);
      setAddressEdit(false);
      const details: any = getFormatedFormFields(selectedUser);
      const selectedUserRoles = formatRoles(selectedUser.roles, selectedRoles);
      setIsonlyDriverSelected(selectedUserRoles.length === 1 && !!isDriver)
      setFormFields({
        ...details,
        roles: selectedUserRoles,
        mobileNumber : selectedUser?.mobileNumber
      });
      setSelectedDetails({...details,
        roles: selectedUserRoles
      })
      Object.keys(formErrors).forEach(key => {
        formErrors[key] = (details[key] && details[key] !== '' && key !== 'emailAddress') ||
          (key === TRACTOR_NUMBER && details[key] === '' && !isDriverSelected) ||
          (key === 'emailAddress' && details['email'] && details['email'] !== '') ? false : '';
      });
      setFormErrors(formErrors);
      setFormEdit(false);
    }
  }, [selectedUser]);

  useEffect(()=>{
    let inValidTractorNo = !!(formFields && formFields["tractorNumber"] === "" || selectedUser && selectedUser["tractorNumber"]==="")
    let errorTexts = {...formErrors,"tractorNumber": isDriverSelected ? inValidTractorNo ? '' : false : false}
    setFormErrors(errorTexts);
    const errors = Object.keys(errorTexts).filter(key => errorTexts[key] !== false);
    const validForm = selectedUser ? errors.length === 0 && (selectedUser && selectedUser.upn) && !isEqual(JSON.stringify(formFields),JSON.stringify(selectedDetails)): errors.length === 0;
    setFormValid(validForm);
  },[isDriverSelected]);

  setScreenName("screen_manage_userProfile_form");

  const transferMember = () => {
    if (!isNetworkAvailable) {
      showNetworkAlert();
      return true;
    }
    const params: ITransferRequest = {
      requester: {
        userId: memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.upn,
        carrierId: memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId,
        isAdmin: true
      },
      userId: validateUserDetails.userPrincipalName || validateUserDetails.upn || "null",
      currentCarrierId: validateUserDetails.carrierId,
      requestedCarrierId:memberDetailsResponse && memberDetailsResponse.member &&  memberDetailsResponse.member.carrierId,
      roles: formFields.roles
    }
    const payload = { name: validateUserDetails && validateUserDetails.firstName, params }
    props.setSubmitNavFlag();
    props.handleTransfer(payload, resetData, memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId === validateUserDetails.carrierId);
  }

  const getBackPath = (path = '') => {
    let url = path ? path : isSelf ? BACK_TO_PROFILE : (selectedUser ? EDIT_BACK_PATH : ADD_BACK_PATH);
    if (props && props.isAssignDriver) {
      url = '/app/' + props.module;
    }
    history.push('/app/manage/ManageUser');
    return true;
  }

  const handleUserExistModal = (showUserModal: boolean) => {
    setAlertProps({
      isModalOpen: showUserModal,
      title: USER_EXIST_TITLE,
      message_content: USER_EXIST_MESSAGE.replace('{{EMAIL}}', validateUserDetails?.mobileNumber).replace('{{NAME}}', validateUserDetails && validateUserDetails.firstName),
      buttons: [
        {
          title: NO,
          type: "secondary-cta-btn-web",
          onClick: () => {
            setFormFields({ ...formFields, email: '' });
            setAlertProps(null);
            props.resetValidateUser();
            props.history.push({
              pathname: '/app/userProfile/add', state: {
          addMode: true,
          validateUserDetails:validateUserDetails
        }})
          }
        },
        {
          title: YES,
          type: "primary-cta-btn-web",
          onClick: () => {
            setAlertProps(null);
            transferMember();
          }
        }
      ]
    });
  }



  const handleBackButton = (path = '') => {
    if (!isFormEdit) {
      return getBackPath(path);
    }
    setAlertProps({
      isModalOpen: true,
      title: USER_BACK_TITLE,
      message_content: USER_BACK_MESSAGE,
      buttons: [
        {
          title: 'Cancel',
          type: "secondary-cta-btn-web",
          onClick: () => {
            setAlertProps(null);
          }
        },
        {
          title: 'Ok',
          type: "primary-cta-btn-web",
          onClick: () => {
            resetData();
            setFormEdit(false);
            getBackPath();
          }
        }
      ]
    });
  }

  const handleErrors = (name: string, value: string) => {
    let errorsText: any = { ...formErrors };
    switch (name) {
      case "firstName":
      case "lastName":
        const isValid = value !== '' && isValidString(value);
        errorsText = ({ ...formErrors, [name]: !isValid ? USER_FORM_ERRORS[name] : false })
        break;
      case "tractorNumber":
       const isTractorValid = value !== '';
        errorsText = ({ ...formErrors, [name]: value !== '' && !isTractorValid ? TRACTOR_NUMBER_ERROR : (isDriverSelected || isLeasedOwnerOprRoleOnSelectedUser(updatedRoles(formFields?.roles)) || isLeasedOwnerOprRoleOnlyOnSelectedUser(selectedUser?.roles) || isElevatedLeasedOwenerOprRoleOnSelectedUser(selectedUser?.roles)) && value === '' ? USER_FORM_ERRORS[name] : false })
        break;
      case "emailAddress":
        const regEx = /^[a-zA-Z0-9.-]+@[a-zA-Z0-9-]+\.[A-Za-z]+$/;
        const isEmailValid = regEx.test(value);
        errorsText = ({ ...formErrors, [name]: isonlyDriverSelected ? false : !isEmailValid ? USER_FORM_ERRORS[name] : false })
        break;
      default:
        break;
    }
    const errors = Object.keys(errorsText).filter(key => errorsText[key] !== false);
    const validForm = selectedUser ? errors.length === 0 && (selectedUser && selectedUser.upn) && !isEqual(JSON.stringify(formFields),JSON.stringify(selectedDetails)): errors.length === 0;
    setFormValid(validForm);
    setFormErrors(errorsText);
  }
  useEffect(() => {
    if (isonlyDriverSelected) {
      setFormErrors({ ...formErrors, emailAddress: false });
    }
  }, [isonlyDriverSelected])

  const handleChange = (event: any) => {
    const { target: { name, value } } = event;
    if (name !== 'mobileNumber') {
      handleErrors(name, value);
      setFormEdit(true);
    }
    switch (name) {
      case "emailAddress":
        setFormFields({ ...formFields, email: props?.isEdit ?formFields.email : value });
        break;
      case "mobileNumber":
        setMobileNumberError(false);
        setFormFields({ ...formFields, mobileNumber: normalizeInput(value) });
        value?.length >= 12 ? setIsValidateButton(false):setIsValidateButton(true)
        break;
      default:
        setFormFields({ ...formFields, [name]: value });
        break;
    }
  }

  const handleSubmit = () => {
    if (!isNetworkAvailable) {
      showNetworkAlert();
      return true;
    }

    if (validateErrors()) {
      return true;
    }

    const isEdit = selectedUser ? true : false;
    let payload = {}
    const { firstName, lastName, roles, email, mobileNumber, addressDTOs, tractorNumber} = formFields;
    const countryCode = mobileNumber?.slice(0, -10)
    isEdit ?
      payload = {
        requester: {
          userId: memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.upn,
          carrierId : memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId,
          isAdmin: true
        },
        userDetails: {
          ...formFields,
          mobileNumber: formFields.mobileNumber,
          upn: (selectedUser && selectedUser?.upn) || null
        }
      }
      :
      payload = {
        firstName,
        lastName,
        roles, email,
        addressDTOs,
        mobileNumber: mobileNumber,
        tractorNumber
      }
    props.setSubmitNavFlag();
    props.handleSubmit(payload, resetData);
  }



  const handleDelinkClick = () => {
    if (!isNetworkAvailable) {
      showNetworkAlert();
      return true;
    }
    const DELINK_ACCOUNT_MESSAGE = ((IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.deLinkContent) 
    || deLinkContent).replace(/<email_or_number>/g,formFields.email || formFields.mobileNumber || "user")
    .replace(/<carrier_name>/g,props.userDetailsNew && props.userDetailsNew.memberDetailsResponse 
      && props.userDetailsNew.memberDetailsResponse.carrierInfo && props.userDetailsNew.memberDetailsResponse.carrierInfo.carrierName || null)
    setAlertProps({
      isModalOpen: true,
      title: (IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.deLinkHeader) || deLinkHeader,
      message: DELINK_ACCOUNT_MESSAGE,
      size: "small_height",
      buttons: [
        {
          title: BUTTONS.DELINK,
          type: "secondary-cta-btn-web",
          onClick: () => {
            const fields: any = getFormatedFormFields(selectedUser);
            const payload = {
              requester: {
                userId:  memberDetailsResponse && memberDetailsResponse.member &&memberDetailsResponse.member.upn,
                carrierId :memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId,
                isAdmin: true,
              },
              userDetails: { ...fields, roles: [new EnumType('carrierGuest')], mobileNumber: fields.mobileNumber && removeSpecial(fields.mobileNumber), carrierId: '' }
            };
            setAlertProps(null);
            props.handleDelink(payload);
          }
        },
        {
          title: BUTTONS.CANCEL,
          type: "primary-cta-btn-web",
          onClick: () => setAlertProps(null)
        }
      ]
    })
  }

  const roleFormProps = {
    ...props,
    formFields,
    isUserNotExist,
    handleChange,
    mobileNumberError,
    setMobileNumberError,
    setDriverSelected,
    setIsonlyDriverSelected,
    setFormFields,
    setFormEdit,
    reset,
    setReset,
    mobileValidateError,
    setMobileValidateError,
    setUserNotExist
  }

  const desktopProps: any = {
    ...props,
    title: selectedUser ? (isSelf ? EDIT_PROFILE : EDIT_USER) : ADD_USER,
    isEdit: selectedUser ? true : false,
    addMode,
    handleBackButton,
    mobileNumberError,
    isUserNotExist,
    isFormEdit,
    formFields,
    formErrors,
    setFormFields,
    handleChange,
    isDriverSelected,
    isonlyDriverSelected,
    alertProps,
    isAddressEdit,
    removeSpecial,
    handleSubmit,
    handleDelinkClick,
    resetData,
    roleFormProps,
    mobileValidateError
  }

  return (
    <>
      <div className="manage-users-formWrapper form-container">
        <IonText className={selectedUser ? 'all-fields-text-edit' : 'all-fields-text'}>{ALL_FIELDS_REQUIRED_TEXT}</IonText>
        <ManageUserValidateForm
          {...roleFormProps}
          onClickRestrictUserModalNo={onClickRestrictUserModalNo}
          onClickRestrictUserModalYes={onClickRestrictUserModalYes}
          setOnClickRestrictUserModalNo={setOnClickRestrictUserModalNo}
          setOnClickRestrictUserModalYes={setOnClickRestrictUserModalYes}
          setRestrictUserModalProps={setRestrictUserModalProps}
          setOnClickRestrictUserModalNone={setOnClickRestrictUserModalNone}
          onClickRestrictUserModalNone={onClickRestrictUserModalNone}
          isValidateButton={isValidateButton}
          {...props}
          {...desktopProps}  />

        <ManageUserFormFields
          {...desktopProps}
          isSelf={false}
          isProfile={true}
          setRestrictUserModalProps={setRestrictUserModalProps}
        />
      </div>
      {<CustomModalWeb {...alertProps} />}
      {<CustomModalWeb {...restrictUserModalProps}/>}
    </>
  );
}
export default ManageUserProfileFormPage;
